import { create } from "zustand";
import type { EnvironmentId, ProjectId } from "@t3tools/contracts";

interface DocumentsPanelState {
  open: boolean;
  environmentId: EnvironmentId | null;
  projectId: ProjectId | null;
  projectCwd: string | null;
  openPanel: (input: {
    environmentId: EnvironmentId;
    projectId: ProjectId;
    projectCwd: string;
  }) => void;
  closePanel: () => void;
}

export const useDocumentsPanelStore = create<DocumentsPanelState>((set) => ({
  open: false,
  environmentId: null,
  projectId: null,
  projectCwd: null,
  openPanel: ({ environmentId, projectId, projectCwd }) =>
    set({ open: true, environmentId, projectId, projectCwd }),
  closePanel: () => set({ open: false }),
}));
